import { Component, DoCheck, EventEmitter, Input, IterableDiffers, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-input-array',
  templateUrl: './input-array.component.html',
  styleUrls: ['./input-array.component.scss'],
})

export class InputArrayComponent implements OnInit, DoCheck {

  @Input()
  set values(values: string[]) {
    this.arrayValues = values;
  }

  @Output()
  valuesChange = new EventEmitter<string[]>();

  @Input()
  label: string;

  @Input()
  canDelete = true;

  arrayValues: string[];
  inputs: string[] = [];
  emptys: string[] = [];

  index: number;

  firstDelete = false;

  differ: any;

  constructor(differs: IterableDiffers) {
    this.differ = differs.find([]).create(null);
  }

  ngOnInit(): void {
    if (!this.arrayValues) {
      this.arrayValues = [];
    }
    this.loadArrays();
  }

  ngDoCheck() {
    const change = this.differ.diff(this.arrayValues);
    if (change) {
      setTimeout(() => {
        this.updateArrays();
      }, 300);
    }
  }

  changeArray(i: number, value: string): void {
    this.arrayValues[i] = value;
    this.updateArrays();
  }

  onKeyUp(event: any, i: number): void {

    if (!this.deleteInput(i, event)) {
      this.firstDelete = false;
      return;
    }

    if (!this.firstDelete) {
      this.firstDelete = true;
      return;
    }
    this.firstDelete = false;

    this.removeInput(i);
  }

  removeInput(index: number) {

    if (index === 0) {
      this.arrayValues[index] = this.inputs.length === 1 ? '' : null;
    } else {
      this.arrayValues[index] = null;
    }

    this.arrayValues.sort(sortNullToEnd);
    this.updateArrays();

    this.index = null;
  }

  currentFocus(i: number) {
    this.index = i;
  }

  loseFocus() {
    const i = this.index;
    setTimeout(() => {
      if (this.index === i) {
        this.index = null;
      }
    }, 300);
  }

  add(): void {
    const i = this.arrayValues.indexOf(null);

    if (i < 0) {
      this.arrayValues.push('');
    } else {
      this.arrayValues[i] = '';
    }

    this.loadArrays();
  }

  updateArrays(): void {
    this.loadArrays();
    this.valuesChange.next(this.arrayValues);
  }

  private deleteInput(i: number, event: any) {
    if (!this.canDelete) {
      return false;
    }
    if (i === 0) {
      return false;
    }
    if (event.keyCode !== KEY_BACKSPACE) {
      return false;
    }
    return event.target.value === '';
  }

  private loadArrays(): void {
    this.inputs = this.arrayValues.filter(v => v !== null);
    this.emptys = this.arrayValues.filter(v => v == null);
  }
}

const KEY_BACKSPACE = 8;

function sortNullToEnd(a: any, b: any): number {
  return a !== null && b === null ? -1 : 0;
}
